import { graphql } from '@/gql';
import { mutationExecute } from '@/Utils/graphqlAPI';
import type { UserInteraction, UserInteractionInput } from '@/models/userInteraction';

export const createUserInteraction = async (data: UserInteractionInput): Promise<UserInteraction> => {
  const response = await mutationExecute({
    mutation: graphql(`
      mutation CreateUserInteraction($data: UserInteractionInputType!) {
        createUserInteraction(data: $data) {
          id
          userId
          associatedObjectId
          associatedObjectType
          action
          changes
          notes
          url
        }
      }
    `),
    variables: {
      data,
    },
  });

  return response.data?.createUserInteraction!;
};
